import React from 'react';

class Question extends React.Component{
    render(){
        return(
            <div>
                <h5 class="m-0 page-side-toggle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec malesuada vulputate est ultricies dictum.
                Nunc rhoncus nulla et eros convallis vulputate. Nunc sed magna eu lectus gravida elementum eu at
                dolor.
                </h5>
                <hr class="mY-10"/>
            </div>
        )
    }
}

class Answer extends React.Component{
    render(){
        return(
            <div class="col2MSP-app__wrapper">
                <div class="col2MSP-list h-100p bgc-white">
                    <div class="peers ai-c bdB bgc-grey-100">
                        <div class="faq-header pX-20">
                            <div class="page-side-toggle">
                                <i class="fa fa-arrow-left fsz-xl"></i>
                            </div>
                            <div class="w-100p p-10 ta-c pos-r">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec malesuada vulputate est ultricies dictum. Nunc rhoncus nulla
                                et eros convallis vulputate. Nunc sed magna eu lectus gravida elementum eu at dolor.
                            </div>
                        </div>
                    </div>

                    <div class="scrollable h-100p p-20">
                        <p cla>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec malesuada vulputate est ultricies dictum.
                            Nunc rhoncus nulla et eros convallis vulputate. Nunc sed magna eu lectus gravida elementum eu at dolor.
                            Vivamus ut consectetur nibh. Nam quam felis, sodales nec neque at, convallis egestas sem. Sed mattis
                            diam odio, et venenatis dolor ornare in. Fusce lacinia eros in ultrices feugiat. Integer placerat, est
                            ac vestibulum finibus, mi lacus interdum felis, hendrerit aliquam velit neque in ante. Fusce porta posuere
                            leo, et pretium diam mollis vel.
                        </p>
                        <p>Vestibulum efficitur molestie scelerisque. In pellentesque sapien eget sem dictum pretium. Ut nibh neque,
                            maximus nec ullamcorper vel, vulputate id justo. Mauris vitae sodales lacus. Proin vehicula pretium vehicula.
                            Suspendisse rutrum urna arcu, at molestie felis laoreet vulputate. Donec id fringilla lectus.
                        </p>
                        <p>Donec lacus dolor, interdum ut leo at, tincidunt laoreet justo. Aliquam non fringilla odio, sed consequat
                            augue. Praesent porta tellus non sapien fringilla, vitae faucibus ipsum dapibus. Interdum et malesuada
                            fames ac ante ipsum primis in faucibus. Nam gravida ex vitae odio dignissim, ac pellentesque ante ultrices.
                            Morbi elementum lacus at ante condimentum, in euismod metus facilisis. Phasellus efficitur tincidunt
                            venenatis.
                        </p>
                        <p>Sed dictum ornare tortor sed ullamcorper. In hac habitasse platea dictumst. Aliquam et sodales turpis. Vestibulum
                            tristique tincidunt neque eget posuere. Cras ut tincidunt urna. Cras rhoncus scelerisque velit vitae
                            ultricies. Suspendisse mattis felis at tincidunt consectetur. Suspendisse ante ante, viverra ac sagittis
                            in, fermentum quis ante. Sed nisi justo, sollicitudin id volutpat eu, aliquet at mauris. Nam sed neque
                            id sapien consequat auctor. Pellentesque porttitor eu mi vitae imperdiet. Suspendisse sollicitudin ligula
                            eget commodo condimentum. Aliquam erat volutpat. Donec non venenatis mi. In hac habitasse platea dictumst.
                            Donec ac mi metus.
                        </p>

                    </div>
                </div>
            </div>
        )
    }
}

class Faq extends React.Component{
    render(){
        return(
            <div class="col2MSP-app">
                <div class="col2MSP-app__side-nav peers bdR bgc-white">
                    <div class="w-100p patient-management-data ">
                        <div class="w-100p pX-10 ta-c pos-r">
                            <button type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0 pos-a t-20 r-2  bdrs-2 cur-p c-client-secondary">
                                <i class="material-icons">close</i>
                            </button>
                            <h3 class="ta-c mB-0">Tire suas dúvidas</h3>
                            <div class="w-100p pX-10 mY-10">
                                <input class="w-100p input-muted  bdc-client-secondary bgc-grey-200" type="text" placeholder="Filtrar"/>
                            </div>
                            <hr class="mY-10"/>
                        </div>
                        <div class="scrollable w-100p h-100p p-20">
                            <Question/>
                        </div>
                    </div>
                </div>
                <Answer />
            </div>
        )
    }
}

export default Faq


// WEBPACK FOOTER //
// ./src/pages/faq/Faq.js